module.exports = __webpack_public_path__ + "img/03.da8d7afe.jpg";